import { Box } from "@mui/material";
import React, { Fragment } from "react";
import classess from "./Style.module.css";

const Footer = ({ FOOTER }) => {
  const nominativArray = Object.values(FOOTER.Examples);

  return (
    <Fragment>
      <span className={classess.TitleSubTitle}>{FOOTER.Title}</span>
      <Box className={classess.Footers}>
        {nominativArray.map((opt, index) => (
          <Fragment key={index}>
            <span>
              {FOOTER.Type}: „{" "}
              <label className={classess.Label}>{opt[0]}</label>“
            </span>
            <span className={classess.Span}>( {opt[1]} )</span>
          </Fragment>
        ))}
      </Box>
    </Fragment>
  );
};

export default Footer;
